import { Component, inject } from '@angular/core';
import { ProgressService } from '../../lib/progress.service';
import { LoadingComponent } from '../../loading/loading.component';

@Component({
  selector: 'app-success',
  imports: [LoadingComponent],
  templateUrl: './success.component.html',
  styleUrl: './success.component.css',
})
export class SuccessComponent {
  public progressService = inject(ProgressService);
}
